import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWelcomeAutocomplete = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		stroke: "#F8FAFB",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2,
		transform: "translate(2 2)",
		children: [/* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			rx: 1.5
		}), /* @__PURE__ */ _jsx("path", { d: "M10 5v10M5 10h9.5" })]
	})
});
export default SvgWelcomeAutocomplete;
